import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CategoryDelete } from './modals/delete/component';
import { CategoryDataSource } from 'src/modules/category/services/category-data-source';
import { CategoryApiService } from 'src/modules/category/services/category-api-service';
import { CategoryEdit } from './modals/create/component';
import { ICategory } from 'src/app/interfaces/category';
import { CohortsDataSource } from 'src/modules/cohorts/services/cohorts-data-source';
import { CohortsApiService } from 'src/modules/cohorts/services/cohorts-api-service';
import { CohortsList } from 'src/modules/cohorts/components/list/component';
@Component({
    selector: 'categories-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CategoriesDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;
  @Output() next = new EventEmitter<any>();
  @Output() ballotView = new EventEmitter<any>();
  @ViewChild('typeFilter', { static: false })
  public typeFilter: MatButtonToggleGroup;

  public loading: boolean;
  public filter: string;
  public search: string;
  public Categories;
  public PageEvent: PageEvent;
  private CohortsDataSource: CohortsDataSource;

  public DataSource = new CategoryDataSource(this.Api, 'admin');
  public displayedColumns = ['title', 'actions'];
  private Subscriptions: RxSubscription[] = [];

  constructor(
    protected Api: CategoryApiService,
    public Router: Router,
    private CohortsApi: CohortsApiService,

    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (_Categories) => (this.Categories = _Categories)
      )
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
    this.Subscriptions.push(
      this.currentTab.subscribe(
        (tab) =>
          'categories-admin' === tab &&
          this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  viewListings(row) {
    this.next.emit({
      role: 'listing-admin',
      catKey: 'categoryId',
      catValue: row.id,
    });
  }

  public listCohorts(Category: ICategory) {
    this.CohortsDataSource = new CohortsDataSource(
      this.CohortsApi,
      'listing-admin',
      'category',
      Category.id,
    );
    const config = new MatDialogConfig();
    config.data = this.CohortsDataSource;
    config.disableClose = true;
    return this.dialog
      .open(CohortsList, config)
      .afterClosed()
      .subscribe(() => this.DataSource.loadWithPageEvent());
  }

  async deleteCategory(category) {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.data = category;

    this.Subscriptions.push(
      this.dialog
        .open(CategoryDelete, config)
        .afterClosed()
        .subscribe(
          (result) =>
            !!result && this.DataSource.loadWithPageEvent(this.PageEvent)
        )
    );
  }

  public addCategory(Category?: ICategory) {
    const DialogConfig = new MatDialogConfig();
    const data = {
      Category: Category ? Category : null,
      CategoryDataSource: this.DataSource,
      existingCategories: this.Categories,
    };
    DialogConfig.disableClose = true;
    DialogConfig.data = data;

    this.Subscriptions.push(
      this.dialog
        .open(CategoryEdit, DialogConfig)
        .afterClosed()
        .subscribe(
          (result) =>
            !!result && this.DataSource.loadWithPageEvent(this.PageEvent)
        )
    );
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
